import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {labels} from '../../util/utils';

export default function createProjectReducer(state = initialState.newProject, action) {
	switch (action.type) {
		case types.CREATE_PROJECT:
		case types.CREATE_ROLL_FORWARD_PROJECT: {
			const newProject = {
				...state,
				name: action.payload.body.name,
				Id: action.response,
				owners: [...action.payload.body.owners],
				status: action.payload.body?.status
			};
			if (newProject?.users.length === 0) {
				const users = newProject.owners.map((owner) => ({
					...owner,
					isProjectOwner: true
				}));
				newProject.users = [...users];
			}

			if (action.payload.body?.clients) newProject.clients = [...action.payload.body.clients];
			return newProject;
		}
		case types.DRAFT_PROJECT: {
			let body = action.meta.api.data;
			let localOrgStruct = body.orgStructure.map((node) => {
				return {
					...node,
					accessGroups: [...node.accessGroups],
					engagements: [...node.engagements]
				};
			});
			return {...state, status: body.status, orgStructure: [...localOrgStruct], clients: [...body.clients]};
		}
		case types.CANCEL_PROJECT: {
			return {...state};
		}
		case types.CLEAR_PROJECT: {
			return initialState.newProject;
		}
		case types.UPDATE_PROJECT: {
			// on success response, update redux state with localstate
			// here keep in mind that, when update is triggered from step1 only step1 data gets updated
			let body = action.meta.api.data;
			if (action.stepUpdated === 1) {
				return {
					...state,
					name: body.name,
					clients: body.clients,
					status: body.status
				};
			} else if (action.stepUpdated === 2 || action.stepUpdated === 3 || action.stepUpdated === 4) {
				// in step 2 we only update org chart, so update it in redux state
				// in step 3 update engagements connected to entity
				if (!action.error) {
					let localOrgStruct = body.orgStructure.map((node) => {
						return {
							...node,
							entityId: action.response.orgStructure.find((x) => x.id == node.id).entityId,
							accessGroups: [...node.accessGroups],
							engagements: [...node.engagements],
							contacts: action.response.orgStructure.find((x) => x.id == node.id).contacts
						};
					});
					return {...state, orgStructure: [...localOrgStruct], owners: action.response.owners, users: action.response.users};
				}

				return state;
			}
			return state;
		}
		case types.GET_PROJECT_TO_EDIT: {
			let body = action.response;
			let localOrgStruct = body.orgStructure.map((node) => {
				return {
					...node,
					accessGroups: [...node.accessGroups],
					engagements: [...node.engagements],
					admins: node.entityAdmins ? [...node.entityAdmins] : [],
					domains: node.domains ? [...node.domains] : [],
					contacts: node.contacts ? [...node.contacts] : []
				};
			});
			return {...body, orgStructure: [...localOrgStruct], users: action.response.users,
				owners: action.response.users.filter(x => x.connectedGroups.filter(y => y.groupName == 'Project owners').length > 0)};
		}
		case types.GET_PROJECT_TO_ROLL_FORWARD: {
			let newOrg = [...action.response.orgStructure];
			newOrg.map((o) => {
				(o.pid = o.parentId),
					(o.engagements = []),
					(o.admins = o.entityAdmins),
					(o.contacts = o.contacts.filter((c) => _.size(c.engagements) < 1)),
					(o.engagementLabel = labels.connectedToEngagements(0)),
					(o.accessGroupLabel = labels.connectedToAccessGroups(o.accessGroups.length));
			});

			let usersResponse = [];
			if (_.size(action.response.users) > 0) {
				usersResponse = action.response.users.map((user) => {
					return {
						...user,
						roles: getRoles(user.roles)
					};
				});
			}

			return {
				...state,
				orgStructure: newOrg,
				name: action.response.name,
				clients: [...action.payload.clientsToRollForward],
				users: usersResponse,
				owners: action.response.users.filter(x => x.connectedGroups.filter(y => y.groupName == 'Project owners').length > 0)
			};
		}
		case types.COPY_GROUP: {
			if (typeof action.response === 'string' && !action.response.errors) {
				let orgStructure = [...state.orgStructure];
				let newOrg = orgStructure.map((o) => {
					if (o.accessGroups.find((x) => x === action.oldGroupId)) {
						let newGroups = o.accessGroups.filter((x) => x !== action.oldGroupId);
						newGroups.push(action.response);
						return {...o, accessGroups: newGroups};
					} else {
						return o;
					}
				});
				return {...state, orgStructure: newOrg};
			} else {
				return state;
			}
		}
		default:
			return state;
	}
}

// To be removed when entire flow in completely implemented and we have right values from api
function getRoles(roles) {
	let updatedRoles = [];
	_.forEach(roles, (role) => {
		const roleToCheck = role.toLowerCase();
		switch (roleToCheck) {
			case 'milestones view role':
			case 'milestones':
				updatedRoles.push('milestones view role');
				break;
			case 'project management view role':
			case 'project management':
				updatedRoles.push('project management view role');
				break;
			case 'canvas client portal view role':
			case 'ey canvas client portal':
				updatedRoles.push('canvas client portal view role');
				break;
			case 'audit insight view role':
			case 'insights':
				updatedRoles.push('audit insight view role');
				break;
			case 'reporting view role':
			case 'reporting':
				updatedRoles.push('reporting view role');
				break;
			case 'group audit view role':
			case 'group audit':
				updatedRoles.push('group audit view role');
				break;
			case 'contacts view role':
			case 'contacts':
				updatedRoles.push('contacts view role');
				break;
			default:
				break;
		}
	});

	return updatedRoles;
}
